
import { map, mergeMap } from 'rxjs/operators'
import { combineEpics } from 'redux-observable'
import { Epic } from 'interfaces/middleware'
import { GET_OFFER, getOfferActionCreator } from 'actions/offersActions'
import { get } from 'helpers/observableAjaxHelpers'
import { GET_OFFER_URL } from 'interfaces/ajax'
import { of } from 'rxjs'
import { NOT_FOUND_STATUS_CODE } from 'constants/ajax'
import { setUnexpectedErrorActionCreator } from 'actions/globalActions'
import { getErrorType } from 'helpers/errorHelpers'
import { filterRequestOfType } from 'rxOperators/filterRequestOfType'
import { catchAjaxSafe } from 'rxOperators/catchSafe'

const getOfferEpic: Epic = (action$) =>
  action$
    .pipe(filterRequestOfType(GET_OFFER, 'request')).pipe(
      mergeMap((action) =>
        get({ url: GET_OFFER_URL, params: { id: action.payload.params.id }}).pipe(
          map(({ response }) =>
            getOfferActionCreator.success(action.payload.params, response)
          ))
          .pipe(catchAjaxSafe((error) => {
            if (error.status === NOT_FOUND_STATUS_CODE) {
              return of(getOfferActionCreator.fail(action.payload.params, error.status))
            }

            return of(setUnexpectedErrorActionCreator(getErrorType(error), error))
          }))
      ))

export default combineEpics(
  getOfferEpic,
)
